// import { asyncRoutes, constantRoutes } from "@/router";

// /**
//  * Use meta.role to determine if the current user has permission
//  * @param roles
//  * @param route
//  */
// function hasPermission(roles, route) {
//   if (route.meta && route.meta.roles) {
//     return roles.some((role) => route.meta.roles.includes(role));
//   } else {
//     return true;
//   }
// }

// /**
//  * Filter asynchronous routing tables by recursion
//  * @param routes asyncRoutes
//  * @param roles
//  */
// export function filterAsyncRoutes(routes, roles) {
//   const res = [];

//   routes.forEach((route) => {
//     const tmp = { ...route };
//     if (hasPermission(roles, tmp)) {
//       if (tmp.children) {
//         tmp.children = filterAsyncRoutes(tmp.children, roles);
//       }
//       res.push(tmp);
//     }
//   });

//   return res;
// }

// const state = {
//   routes: [],
//   addRoutes: [],
// };

// const mutations = {
//   SET_ROUTES: (state, routes) => {
//     state.addRoutes = routes;
//     state.routes = constantRoutes.concat(routes);
//   },
// };

// const actions = {
//   generateRoutes({ commit }, roles) {
//     return new Promise((resolve) => {
//       let accessedRoutes;
//       if (roles.includes("admin")) {
//         accessedRoutes = asyncRoutes || [];
//       } else {
//         accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
//       }
//       commit("SET_ROUTES", accessedRoutes);
//       resolve(accessedRoutes);
//     });
//   },
// };

// export default {
//   namespaced: true,
//   state,
//   mutations,
//   actions,
// };

/**
 * 权限 Store
 * @author LiQingSong
 */
import { asyncRoutes, constantRoutes } from "@/router";
/**
 * 根据 meta.role 判断当前用户是否有权限
 * @param roles 用户的权限
 * @param route 路由
 */
function hasPermission(roles, route) {
  // console.log(roles,'roles')
  if (route.meta && route.meta.roles) {
    // console.log("route.meta.roles.", route.meta.roles, roles);

    return roles.some((role) => route.meta.roles.includes(role));
  } else {
    return true;
  }
}

/**
 * 根据权限 - 递归过滤异步路由
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = [];

  routes.forEach((route) => {
    const tmp = { ...route };
    // console.log("hasPermission(roles, tmp)", tmp, hasPermission(roles, tmp));
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}

const state = {
  routes: [],
  addRoutes: [],
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
};

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise((resolve) => {
      let accessedRoutes;
      // if (roles.includes("admin")) {
      //   accessedRoutes = asyncRoutes || [];
      // } else {
      // 筛选路由去渲染
      accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
      // accessedRoutes = asyncRoutes
      // }
      // console.log("accessedRoutes", accessedRoutes);
      commit("SET_ROUTES", accessedRoutes);
      resolve(accessedRoutes);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
